<template>
    <NuxtLink
        v-tooltip.bottom="{
            value: getTooltipNazev(),
            delay: 200,
        }"
        :to="getLink(item)"
        :target="type === 'dat_vrstvy' ? '_blank' : ''"
        class="block text-xs"
    >
        <button
            class="tag"
            :class="ENUM_CSS_CLASS[type]"
        >
            {{ type === "atlas-jevy" ? toFirstLetterCapital(title) : title }}
        </button>
    </NuxtLink>
</template>

<script lang="ts" setup>
const store = useMainStore()
const localePath = useLocalePath()
const route = useRoute()

const { item, type } = defineProps<{
    item: string | TemaKeywordItem | number | JevVrstvaItem
    type:
        | "klic_slova"
        | "metriky"
        | "dat_vrstvy"
        | "jevy"
        | "limity"
        | "indikatory"
        | "atlas"
        | "atlas-jevy"
}>()

const ENUM_CSS_CLASS = {
    klic_slova: "KEYWORDS",
    metriky: "METRIKY",
    dat_vrstvy: "DATOVE_VRSTVY",
    jevy: "JEVY",
    limity: "LIMITY",
    indikatory: "INDIKATORY",
    atlas: "ATLAS",
    "atlas-jevy": "ATLAS",
}

function getLink(item: string | TemaKeywordItem | number | JevVrstvaItem) {
    if (type === "klic_slova")
        if (typeof item === "string") {
            return localePath(`/vyhledavani?text=${item}`)
        } else if (typeof item === "number") {
            return localePath(`/vyhledavani?text=${getKlicSlovo(item)}`)
        } else {
            return localePath(`/vyhledavani?text=${item.NAZEV}`)
        }
    if (type === "metriky") {
        const tooltip = store.tooltips.metriky.find(el => el.KOD === item)
        if (!tooltip) {
            return localePath(`/cisla/katalog-indikatoru-a-metrik/${item}`)
        }
        if (route.name?.toString().includes("katalog-indikatoru-a-metrik")) {
            return localePath(`/cisla/katalog-mestskych-casti/metriky/${item}`)
        }
        if (route.name?.toString().includes("katalog-mestskych-casti")) {
            return localePath(`/cisla/katalog-indikatoru-a-metrik/${item}`)
        }
        if (tooltip.KATALOG.includes("KIM")) {
            return localePath(`/cisla/katalog-indikatoru-a-metrik/${item}`)
        }
        return localePath(`/cisla/katalog-mestskych-casti/metriky/${item}`)
    }
    if (type === "dat_vrstvy") {
        return `https://geoportalpraha.cz/vyhledavani?input=${item}`
    }
    if (type === "jevy") {
        return localePath(`/o-portalu/jevy-uap/?jev=${item}`)
    }
    if (type === "limity") {
        return localePath(`/vyhledavani?text=${item}`)
    }
    if (type === "indikatory") {
        const skupina = item
            .toString()
            .replace("i", "m")
            .substring(0, item.toString().lastIndexOf("."))
        return localePath(
            `/cisla/katalog-indikatoru-a-metrik/${skupina}?indikator=${item}`
        )
    }
    if (type === "atlas-jevy") {
        return localePath(`/mapy/atlas?service[]=${(item as JevVrstvaItem).ID}`)
        // return localePath(`/vyhledavani?text=${item}`)
    }
    if (type === "atlas") {
        return localePath(`/mapy/atlas?service[]=${item as string}`)
        /*  const kod =
            "vykres_uap_" + item.toString().replace(".", "").toLowerCase()
        return localePath(`/mapy/atlas?service[]=${kod}`) */
        // return localePath(`/vyhledavani?text=${item}`)
    }
    return ""
}

/* const klicoveSlovo = computed(() => {
    if (typeof item === "number") {
        return useLocaleValue(
            store.keywords.find(el => el.ID === item),
            "NAZEV"
        )
    }
    return "null"
}) */

function getKlicSlovo(item: number) {
    return useLocaleValue(
        store.keywords.find(el => el.ID === item),
        "NAZEV"
    )
}

function getTooltipNazev() {
    if (type === "klic_slova" || type === "atlas" || type === "atlas-jevy") {
        return ""
    }
    if (type === "metriky") {
        const isSkupinaMetrik = item.toString().split(".").length === 4
        if (isSkupinaMetrik && typeof item === "string") {
            return store.getTooltip(item, "skupinyMetrik")
        }
    }
    if (type === "dat_vrstvy") {
        return store.getTooltip(item as string, "vrstvy")
    }
    if (typeof item !== "string") return ""
    return store.getTooltip(item.trim(), type)
}

const title = computed(() => {
    if (type === "atlas-jevy") {
        return (item as JevVrstvaItem).NAZEV
    }
    if (type === "atlas") {
        return useLocaleValue(
            store.tooltips.atlas.find(el => el.KOD === item),
            "NAZEV"
        )
    }
    if (type === "klic_slova") {
        if (typeof item === "string") {
            return useLocaleValue(
                store.keywords.find(
                    el => el.NAZEV === item || el.NAZEV_EN === item
                ),
                "NAZEV"
            )
        } else if (typeof item === "number") {
            return useLocaleValue(
                store.keywords.find(el => el.ID === item),
                "NAZEV"
            )
        } else {
            return useLocaleValue(item, "NAZEV")
        }
    }
    if (typeof item === "string") {
        return item
    }
    return useLocaleValue(item, "NAZEV")
})
</script>

<style scoped></style>
